import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTrashBin20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTrashBin20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 3.5h2a.5.5 0 0 1 .5.5v.5h-3V4a.5.5 0 0 1 .5-.5m-2 1V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v.5h3.244a.75.75 0 0 1 0 1.5H16v9.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 15.5V6h-.24a.75.75 0 0 1 0-1.5zM13 6H5.5v9.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V6zm-5.5 8.265V8.763a.75.75 0 0 1 1.5 0v5.502a.75.75 0 0 1-1.5 0m3.49-5.502v5.502a.75.75 0 0 0 1.5 0V8.763a.75.75 0 1 0-1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTrashBin20);
